module.exports = __webpack_public_path__ + "img/logo.d7a8dea0.png";